// binarySearch returns the element in the array that is closest to the target value.
export function binarySearch<T>(
  items: T[],
  target: number,
  getValue: (item: T) => number,
): T {
  let start = 0;
  let end = items.length - 1;
  while (start <= end) {
    const mid = Math.floor((start + end) / 2);
    const value = getValue(items[mid]);
    if (value === target) {
      start = mid;
      break;
    } else if (value < target) {
      start = mid + 1;
    } else {
      end = mid - 1;
    }
  }
  if (start >= items.length) {
    start = items.length - 1;
  }
  return items[start];
}

export function partition<T>(
  items: T[],
  condition: (item: T) => boolean,
): [T[], T[]] {
  const truePartition: T[] = [];
  const falsePartition: T[] = [];

  items.forEach((item) => {
    if (condition(item)) {
      truePartition.push(item);
    } else {
      falsePartition.push(item);
    }
  });
  return [falsePartition, truePartition];
}
